<template>
    <div v-if="selectedSession != null">
        <base-header type="instore" class="pb-6 pb-8 pt-5 pt-md-8">
            <br><br>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-auto">
                    <router-link :to="{ name: 'tools'}" >
                        <h6 class="heading-small" style='color: white;'> ⟵    Back to Pos Session List </h6>
                    </router-link>
                   <!-- <h6 class="heading-small" style='color: white;' @click.prevent="handleBack"> ⟵   Back to Pos Session List </h6> -->
                </div>
            </div>


            <div class="row mt-2">
                <div class="col">
                    <a-spin :spinning="loading">
                    <div class="card shadow">
                        <div class="card-header px-4 py-3 bg-transparent">
                            <div class="row px-3">
                                <h6 class="heading-small p-0 m-0"> SESSION # {{selectedSession.session_id}} </h6>
                                <div class="col d-flex justify-content-end">
                                    <h6 class="heading-small p-0 m-0 mr-2"> {{selectedSession.business_date_formatted}} </h6> 
                                    <!-- <i class="fas fa-check-circle text-green"></i> -->
                                </div>
                            </div>                                
                        </div>

                        <div class="card-body mx-4">
                                <div class="row">
                                    <h3 class='font-weight-bold'>Session Details</h3>  
                                </div>
                                <div class="row mt-2">
                                    <div class="col">
                                        <h6 class="heading-small text-muted">Location</h6>
                                        {{selectedSession.site_location}}
                                    </div>
                                    <div class="col">
                                        <h6 class="heading-small text-muted">Site Code</h6>
                                        {{selectedSession.site_code}}
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col">
                                        <h6 class="heading-small text-muted">Terminal</h6>
                                        {{selectedSession.terminal_name}}
                                    </div>
                                    <div class="col">
                                        <h6 class="heading-small text-muted">Cashier</h6>
                                        {{selectedSession.user_name}}
                                    </div>
                                </div>
                                
                        </div>

                        <div class="card-body mx-4">
                            <div class="row">
                                <h3 class='font-weight-bold'>Product Inventory Breakdown</h3>
                            </div>
                            <!-- <div class="row">
                                <small>Inventory & Sales</small>
                            </div> -->
                            <div class="row" style="overflow-y: scroll;">
        
                                <a-table :columns="columns" :dataSource="productBreakdown" :scroll="scroll" :rowKey="record => record.product_id" bordered>
                                    
                                    <!-- <span slot="stock_no" slot-scope="text, record"> 
                                      {{record.stock_no}}
                                    </span>

                                    <span slot="product_name" slot-scope="text, record"> 
                                      {{record.product_name}}
                                    </span>

                                    <span slot="beg_qty" slot-scope="text, record"> 
                                      <div v-if="(record.beq_qty != undefined) == false"> {{record.beg_qty}} </div>
                                      <div v-else> 0 </div>
                                    </span>


                                    <span slot="beg_amt" slot-scope="text, record"> 
                                      <div v-if="(record.beg_amt != undefined) == false"> {{ parseFloat(record.beg_amt).toFixed(2)}}</div>
                                      <div v-else> 0.00 </div>
                                    </span>


                                    <span slot="pin_production" slot-scope="text, record"> 
                                      <div v-if="(record.pin_production != undefined) == false"> {{ record.pin_production }}</div>
                                      <div v-else> 0 </div>
                                    </span>

                                    <span slot="pin_commissary" slot-scope="text, record"> 
                                      <div v-if="(record.pin_commissary != undefined) == false"> {{ record.pin_commissary }}</div>
                                      <div v-else> 0 </div>
                                    </span>

                                    <span slot="pin_sld" slot-scope="text, record"> 
                                      <div v-if="(record.pin_sld != undefined) == false"> {{ record.pin_sld }}</div>
                                      <div v-else> 0 </div>
                                    </span>

                                    <span slot="pin_suppliers" slot-scope="text, record"> 
                                      <div v-if="(record.pin_suppliers != undefined) == false"> {{ record.pin_suppliers }}</div>
                                      <div v-else> 0 </div>
                                    </span>

                                    <span slot="pin_received_from_other_suppliers" slot-scope="text, record"> 
                                      <div v-if="(record.pin_received_from_other_suppliers != undefined) == false"> {{ record.pin_received_from_other_suppliers }}</div>
                                      <div v-else> 0 </div>
                                    </span>

                                    <span slot="pon_pullout" slot-scope="text, record"> 
                                      <div v-if="(record.pon_pullout != undefined) == false"> {{ record.pon_pullout }}</div>
                                      <div v-else> 0 </div>
                                    </span>

                                    <span slot="end_qty" slot-scope="text, record"> 
                                      <div v-if="(record.end_qty != undefined) == false"> {{ record.end_qty }}</div>
                                      <div v-else> 0 </div>
                                    </span>

                                    <span slot="end_amt" slot-scope="text, record"> 
                                      <div v-if="(record.end_amt != undefined) == false"> {{ parseFloat(record.end_amt).toFixed(2) }}</div>
                                      <div v-else> 0.00 </div>
                                    </span>

                                    <span slot="ps-qty" slot-scope="text, record"> 
                                      <div v-if="record.qty == undefined"> 0</div>
                                      <div v-else> {{record.qty}} </div>
                                    </span>

                                    <span slot="ps-price" slot-scope="text, record"> 
                                      <div v-if="(record.price != undefined) == false"> {{ parseFloat(record.price).toFixed(2) }}</div>
                                      <div v-else> 0.00 </div>
                                    </span>

                                    <span slot="ps-sales" slot-scope="text, record"> 
                                      <div v-if="(record.sales != undefined) == false"> {{ parseFloat(record.sales).toFixed(2) }}</div>
                                      <div v-else> 0.00 </div>
                                    </span> -->

                                </a-table>
                            </div>
                        </div>

                        <div class="card-body mx-4">
                            <div class="row">
                                <h3 class='font-weight-bold'>Inventory Value Breakdown</h3>  
                            </div>
                            <div class="row" style="overflow-y: scroll;">
                              <a-table :pagination="false" :columns="inventoryValueColumns" :dataSource="inventoryValue" :rowKey="record => record.id" width="100%" bordered>
                              </a-table>
                            </div>
                        </div>

                      
                        <div class="card-body mx-4">
                            <div class="row">
                                <h3 class='font-weight-bold'>Cash Movement Breakdown</h3>  
                            </div>
                             <div class="row" style="overflow-y: scroll;">
                                <!-- :pagination="pagination" :key="historyTable" -->
                                <!-- {{scroll}} -->
                                <a-table :pagination="false" :columns="cashMovementColumns" :dataSource="cashMovement" :rowKey="record => record.id" width="100%" bordered>
                                </a-table>
                            </div>
                        </div>

                        <div class="card-body mx-4">
                            <div class="row">
                                <h3 class='font-weight-bold'>Non-Cash Breakdown</h3>  
                            </div>
                             <div class="row" style="overflow-y: scroll;">
                                <!-- :pagination="pagination" :key="historyTable" -->
                                <!-- {{scroll}} -->
                                <a-table :pagination="false" :columns="nonCashColumns" :dataSource="nonCashBreakdown" :rowKey="record => record.id" width="100%" bordered>
                                </a-table>
                            </div>
                        </div>

                        <div class="card-body mx-4">
                            <div class="row">
                                <h3 class='font-weight-bold'>Sales By Category Breakdown</h3>
                            </div>
                            <div class="row" style="overflow-y: scroll;">
                                <a-table :pagination="{pageSize: 5}" :columns="categorySalesColumns" :dataSource="categorySales" :rowKey="record => record.product_id" bordered width="100%">
                                </a-table>
                            </div>
                        </div>

                        <div class="card-body mx-4"> 
                            <div class="row">
                                <button class="btn btn-sm btn-success float-right ml-2" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="exportToExcel" >Export to Excel</button>
                            </div>
                        </div>
                        
                    </div>
                    </a-spin>
                </div>
            </div>



        </div>
    </div>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import axios from "axios";
import moment from 'moment';
import * as XLSX from 'xlsx';

var component_x;

const cash_movement_columns = [
  { align: 'right', title: 'Cash Declared',  dataIndex: 'cash_declared', key: 'cash_declared', width: 150},
  { align: 'right', title: 'Non-Cash Declared',  dataIndex: 'non_cash_declared', key: 'non_cash_declared', width: 150},
  { align: 'right', title: 'Cash In',  dataIndex: 'cash_in', key: 'cash_in', width: 150},
  { align: 'right', title: 'Cash Out',  dataIndex: 'cash_out', key: 'cash_out', width: 150},
  { align: 'right', title: 'Sales',  dataIndex: 'sales', key: 'sales', width: 150},
    // { align: 'right', title: 'Cash & Non-Cash Collected',  dataIndex: 'cash_collected', key: 'cash_collected', width: 150},
  { align: 'right', title: 'Variance',  dataIndex: 'variance', key: 'variance', width: 150},
]

const inventory_value_columns = [
  { align: 'right', title: 'Initial Inventory',  dataIndex: 'initial_inventory', key: 'initial_inventory', width: 150},
  { align: 'right', title: '+ Product In',  dataIndex: 'value_product_in', key: 'value_product_in', width: 150},
  { align: 'right', title: '- Product Out',  dataIndex: 'value_product_out', key: 'value_product_out', width: 150},
  { align: 'right', title: '- Ending Inventory',  dataIndex: 'ending_inventory', key: 'ending_inventory', width: 150},
  { align: 'right', title: 'Sales',  dataIndex: 'total_sales', key: 'total_sales', width: 150},
]

const product_breakdown_columns = [
  { title: 'Stock No',  dataIndex: 'stock_no', key: 'stock_no', width: 100, fixed: 'left', scopedSlots: { customRender: 'stock_no' }},
  { title: 'Product Name',  dataIndex: 'product_name', key: 'product_name', fixed: 'left', width: 200, scopedSlots: { customRender: 'product_name' }},

  { title: 'Beginning Inventory',  children: [
    {title: 'Quantity', dataIndex: 'beg_qty', key: 'beg_qty',  align: 'right', scopedSlots: { customRender: 'beg_qty' }},
    {title: 'Total Amount', dataIndex: 'beg_amt', key: 'beg_amt',  align: 'right', scopedSlots: { customRender: 'beg_amt' }}
  ]},

  { title: 'Product In',  children: [
    {title: 'Production', dataIndex: 'pin_production', key: 'pin_production', align: 'right', scopedSlots: { customRender: 'pin_production' }},
    {title: 'Commissary', dataIndex: 'pin_commissary', key: 'pin_commissary', align: 'right', scopedSlots: { customRender: 'pin_commissary' }},
    {title: 'SLD', dataIndex: 'pin_sld', key: 'pin_sld', align: 'right',  scopedSlots: { customRender: 'pin_sld' }},
    {title: 'Suppliers', dataIndex: 'pin_suppliers', key: 'pin_suppliers', align: 'right',  scopedSlots: { customRender: 'pin_suppliers' }},
    {title: 'Received from other stores', dataIndex: 'pin_received_from_other_suppliers', key: 'pin_received_from_other_suppliers', align: 'right',  scopedSlots: { customRender: 'pin_received_from_other_suppliers' }}
  ]},

  { title: 'Product Out',  children: [
    {title: 'Pull Out', dataIndex: 'pon_pullout2', key: 'pon_pullout2',  align: 'right',  scopedSlots: { customRender: 'pon_pullout2' }},
    {title: 'Bread Discount', dataIndex: 'pon_bread_discount', key: 'pon_bread_discount',  align: 'right',  scopedSlots: { customRender: 'pon_bread_discount' }},
    {title: 'Garbage Collection', dataIndex: 'pon_garbage', key: 'pon_garbage',  align: 'right',  scopedSlots: { customRender: 'pon_garbage' }},
    {title: 'Representation', dataIndex: 'pon_representation', key: 'pon_representation',  align: 'right',  scopedSlots: { customRender: 'pon_representation' }},
    {title: 'Transfer to Other Stores', dataIndex: 'pon_pullout', key: 'pon_pullout',  align: 'right',  scopedSlots: { customRender: 'pon_pullout' }},
    {title: 'Others', dataIndex: 'pon_others', key: 'pon_others',  align: 'right',  scopedSlots: { customRender: 'pon_others' }}
  ]},

  { title: 'Ending Inventory',  children: [
    {title: 'Quantity', dataIndex: 'end_qty', key: 'end_qty', align: 'right',  scopedSlots: { customRender: 'end_qty' }},
    {title: 'Total Amount', dataIndex: 'end_amt', key: 'end_amt', align: 'right',  scopedSlots: { customRender: 'end_amt' }}
  ]},

  { title: 'Product Sold',  children: [
    {title: 'Quantity', dataIndex: 'qty', key: 'qty', align: 'right',  scopedSlots: { customRender: 'ps-qty' }},
    {title: 'Price', dataIndex: 'price', key: 'price', align: 'right',  scopedSlots: { customRender: 'ps-price' }},
    {title: 'Sales', dataIndex: 'sales', key: 'sales',  align: 'right',  scopedSlots: { customRender: 'ps-sales' }}
  ]},

];

const non_cash_columns = [
  { align: 'right', title: 'Payment Type',  dataIndex: 'payment_type_name', key: 'payment_type_name', width: 150},
  { align: 'right', title: 'Reference No.',  dataIndex: 'reference_no', key: 'reference_no', width: 200},
  { align: 'right', title: 'Amount',  dataIndex: 'amount', key: 'amount', width: 150},
  { align: 'right', title: 'First Name',  dataIndex: 'first_name', key: 'first_name', width: 250},
  { align: 'right', title: 'Last Name',  dataIndex: 'last_name', key: 'last_name', width: 250},
  { align: 'right', title: 'Remarks',  dataIndex: 'remarks', key: 'remarks', width: 250},
  { align: 'right', title: 'Excess',  dataIndex: 'excess', key: 'excess', width: 250},
]

const category_sales_columns = [
  { title: 'Category',  dataIndex: 'category', key: 'category'},
  { title: 'Sales',  children: [
    {title: 'Total Quantity', dataIndex: 'qty', key: 'qty', align: 'right'},
    {title: 'Total Amount', dataIndex: 'sales', key: 'sales',  align: 'right'}
  ]},
]


export default {
    computed: {
        ...mapState(['serverType', 'endPoint'])
    },
    mounted: async function(){
        this.loading = true
        component_x = this;
        this.selectedSession = this.$attrs.selectedSession;
        var cashBreakdown = this.$attrs.cashBreakdown

        console.log("----------------");
        console.log(cashBreakdown);

        var audBreakdown = this.$attrs.audBreakdown || []
        console.log("-------------------")
        console.log(this.selectedSession)
        if(this.selectedSession == null || this.selectedSession == undefined){
            this.$router.push({
                name: 'tools'
            })
        } else {

            this.columns = product_breakdown_columns
            this.cashMovementColumns = cash_movement_columns
            this.scroll = {x: 'calc(1500px + 50%)', y: 500}
            var productBreakdown = await HTTPRequest.getRequest(this.endPoint + 'pos_sessions/' + this.selectedSession.id + "/consolidated_view"  , null)
            var nonCashBreakdown = await HTTPRequest.getRequest(this.endPoint + 'pos_sessions/' + this.selectedSession.id + "/non_cash_breakdown", null)
            // if(productBreakdown.length > 0){
              this.productBreakdown = productBreakdown
              this.nonCashBreakdown = nonCashBreakdown
            // }

            var productsSold = [];
            productBreakdown.forEach( product => {
              if(parseFloat(product.sales) != 0){
                productsSold.push(product.product_id);
              }
            });
            var nonCashTotal = 0
            var cashTotal = 0
            console.log(audBreakdown)
            Object.keys(audBreakdown).forEach(function (key) { 
              if( _.isNaN(parseFloat(key)) ){
                if(parseFloat(audBreakdown[key]) > 0){
                   nonCashTotal += parseFloat(audBreakdown[key]) 
                } 
              }else{
                if(parseFloat(audBreakdown[key]) > 0){
                  cashTotal += parseFloat(audBreakdown[key]) * parseFloat(key)
                } 
              }
            })

            this.cashMovement = [ { cash_declared: cashTotal.toFixed(2), non_cash_declared: nonCashTotal.toFixed(2) , cash_out: parseFloat(cashBreakdown.total_cash_out).toFixed(2), cash_in: parseFloat(cashBreakdown.total_cash_in).toFixed(2), sales: parseFloat(cashBreakdown.total_sales).toFixed(2), cash_collected: parseFloat(this.selectedSession.expected_cash_amount).toFixed(2), variance: parseFloat(this.selectedSession.actual_cash_amount - this.selectedSession.expected_cash_amount).toFixed(2)} ]
            
            this.inventoryValueColumns = inventory_value_columns;
            this.nonCashColumns = non_cash_columns;
            this.categorySalesColumns = category_sales_columns;

            var initialInvValue = 0;
            var productInValue = 0;
            var productOutValue = 0;
            var endingInvValue = 0;

            this.totalqty = 0;
            this.totalsales = 0;
            this.categorySales= [];
            
            for(var i = 0; i < this.productBreakdown.length; i++){
              var productDetail = this.productBreakdown[i];
              if(productDetail.beg_amt != undefined) initialInvValue += parseFloat(productDetail.beg_amt)
              if(productDetail.tin_value != undefined) productInValue += parseFloat(productDetail.tin_value)
              if(productDetail.ain_value != undefined) productInValue += parseFloat(productDetail.ain_value)
              if(productDetail.ton_value != undefined) productOutValue += parseFloat(productDetail.ton_value)
              if(productDetail.aon_value != undefined) productOutValue += parseFloat(productDetail.aon_value)
              if(productDetail.end_amt != undefined) endingInvValue += parseFloat(productDetail.end_amt)
              
              if((productDetail.qty == undefined) || (productDetail.sales == undefined)){
                continue;
              }
              this.totalqty += parseFloat(productDetail.qty);
              this.totalsales += parseFloat(productDetail.sales);
              var categ = this.categorySales.find(c => c.category == productDetail.category)
              if(categ == undefined){
                this.categorySales.push({category: productDetail.category, qty: parseFloat(productDetail.qty), sales: parseFloat(productDetail.sales)})
              }else{
                categ.qty += parseFloat(productDetail.qty)
                categ.sales += parseFloat(productDetail.sales)
              }
            }
            this.categorySales.push({category: "GRAND TOTAL", qty: this.totalqty, sales: this.totalsales});


            this.inventoryValue = [ { initial_inventory:  initialInvValue, value_product_in:  productInValue, ending_inventory: endingInvValue, 
                                       value_product_out: productOutValue, total_sales: parseFloat(cashBreakdown.total_sales).toFixed(2)} ]
            // this.inventoryValue = [ { initial_inventory:  initialInvValue.toFixed(2), value_product_in:  productInValue.toFixed(2),
            //                            value_product_out: productOutValue.toFixed(2), total_sales: parseFloat(cashBreakdown.total_sales).toFixed(2)} ]
            
            this.loading = false


       }
        
        // var posSession = await HTTPRequest.getRequest(this.endPoint + 'pos_sessions + this.selectedSession, null)        
        // this.session = posSession.data
        // this.displayKey++;
        // 'calc(700px + 50%)'
    },
    data: function(){
        return {
            displayKey: 0,
            session: null,
            selectedSession: null,
            columns: [],
            inventoryValueColumns: [],
            inventoryValue: [],
            productBreakdown: [ 
                    {stock_no: "S-001", product_name: "Product 1", beg_qty: 10, beg_amt: 1000, pin_production: 5, end_qty: 5, end_amt: 500,
                        pin_commissary: 5, pin_sld: 5, pin_suppliers: 5, pin_received_from_other_suppliers: 5, pon_adjustment_out: 3, aon_value: 50, ton_value: 5}, 
                    {stock_no: "S-002", product_name: "Product 2", beg_qty: 10, beg_amt: 1000, pin_production: 5, end_qty: 5, end_amt: 500,
                        pin_sld: 5, pin_suppliers: 5, pin_received_from_other_suppliers: 5, pon_adjustment_out: 3, pon_pullout: 3, pon_others: 3 }, 

            ],
            cashMovement: [],
            cashMovementColumns: [],
            nonCashColumns: [],
            nonCash: [],
            nonCashColumns: [],
            nonCashBreakdown: [],
            categorySalesColumns: [],
            categorySales: [],
            scroll: {},
            loading: false,
        }
    },
    methods: {
        handleBack(){
            this.$router.push({
                name: 'tools'
            })
        },

        createWritableCopy(){
            // create a copy of the tables to a more suitable form for writing to excel format

            var writableProductBreakdown = []
            
            // some headers for this table are identical so it is an array of arrays to avoid confusion while keeping order
            this.productBreakdown.forEach( product => {
                var newProductBreakdown = []
                newProductBreakdown.push(product.stock_no == null ? '' : product.stock_no)
                newProductBreakdown.push(product.product_name == null ? '' : product.product_name)
                newProductBreakdown.push(product.beg_qty == null ? '' : product.beg_qty)
                newProductBreakdown.push(product.beg_amt == null ? '' : product.beg_amt)
                newProductBreakdown.push(product.pin_production == null ? '' : product.pin_production)
                newProductBreakdown.push(product.pin_commissary == null ? '' : product.pin_commissary)
                newProductBreakdown.push(product.pin_sld == null ? '' : product.pin_sld)
                newProductBreakdown.push(product.pin_suppliers == null ? '' : product.pin_suppliers)
                newProductBreakdown.push(product.pin_received_from_other_suppliers == null ? '' : product.pin_received_from_other_suppliers)
                newProductBreakdown.push(product.pon_pullout2 == null ? '' : product.pon_pullout2)
                newProductBreakdown.push(product.pon_bread_discount == null ? '' : product.pon_bread_discount)
                newProductBreakdown.push(product.pon_garbage == null ? '' : product.pon_garbage)
                newProductBreakdown.push(product.pon_representation == null ? '' : product.pon_representation)
                newProductBreakdown.push(product.pon_pullout == null ? '' : product.pon_pullout)
                newProductBreakdown.push(product.pon_others == null ? '' : product.pon_others)
                newProductBreakdown.push(product.end_qty == null ? '' : product.end_qty)
                newProductBreakdown.push(product.end_amt == null ? '' : product.end_amt)
                newProductBreakdown.push(product.qty == null ? '' : product.qty)
                newProductBreakdown.push(product.price == null ? '' : product.price)
                newProductBreakdown.push(product.sales == null ? '' : product.sales)

                writableProductBreakdown.push(newProductBreakdown);
            });

            var writableInventoryBreakdown = []
            
            // ff tables have unique headers so array of objects to keep track of data

            this.inventoryValue.forEach(inventory => {

                var newInventoryValue = new Object();

                newInventoryValue['Initial Inventory']    = inventory.initial_inventory == null ? '' : inventory.initial_inventory
                newInventoryValue['+ Product In']    = inventory.value_product_in == null ? '' : inventory.value_product_in
                newInventoryValue['- Product Out']    = inventory.value_product_out == null ? '' : inventory.value_product_out
                newInventoryValue['- Ending Inventory']    = inventory.ending_inventory == null ? '' : inventory.ending_inventory
                newInventoryValue['Sales']  = inventory.total_sales == null ? '' : inventory.total_sales

                writableInventoryBreakdown.push(newInventoryValue);
            });

            var writableCashMovement = []

            this.cashMovement.forEach(cash => {

                var newCash = new Object();

                newCash['Cash Declared']    = cash.cash_declared == null ? '' : cash.cash_declared
                newCash['Non-Cash Declared']    = cash.non_cash_declared == null ? '' : cash.non_cash_declared
                newCash['Cash In']    = cash.cash_in == null ? '' : cash.cash_in
                newCash['Cash Out']    = cash.cash_out == null ? '' : cash.cash_out
                newCash['Sales']  = cash.sales == null ? '' : cash.sales
                newCash['Variance']  = cash.variance == null ? '' : cash.variance

                writableCashMovement.push(newCash);
            });

            var writableNonCashBreakdown = []

            this.nonCashBreakdown.forEach(nonCash => {

                var newNonCash = new Object();

                newNonCash['Payment Type']    = nonCash.payment_type_name == null ? '' : nonCash.payment_type_name
                newNonCash['Reference No.']    = nonCash.reference_no == null ? '' : nonCash.reference_no
                newNonCash['Amount']    = nonCash.amount == null ? '' : nonCash.amount
                newNonCash['First Name']    = nonCash.first_name == null ? '' : nonCash.first_name
                newNonCash['Last Name']  = nonCash.last_name == null ? '' : nonCash.last_name
                newNonCash['Remarks']  = nonCash.remarks == null ? '' : nonCash.remarks
                newNonCash['Excess']  = nonCash.excess == null ? '' : nonCash.excess

                writableNonCashBreakdown.push(newNonCash);
            });


            var writableCategoryBreakdown = []

            this.categorySales.forEach(category => {

                var newCategory = new Object();

                newCategory['Category']    = category.category == null ? '' : category.category
                newCategory['Quantity']    = category.qty == null ? '' : category.qty
                newCategory['Amount']    = category.sales == null ? '' : category.sales

                writableCategoryBreakdown.push(newCategory);
            });

            return {
                writableProductBreakdown: writableProductBreakdown,
                writableInventoryBreakdown: writableInventoryBreakdown,
                writableCashMovement: writableCashMovement,
                writableNonCashBreakdown: writableNonCashBreakdown,
                writableCategoryBreakdown: writableCategoryBreakdown
            };


        },

        async exportToExcel(){
            var tables = this.createWritableCopy();
            var workbook = XLSX.utils.book_new();

            var basicDetails = [
                [ `Session # ${this.selectedSession.session_id} `, this.selectedSession.business_date_formatted, `id - ${this.selectedSession.id}` ],
                [],[ 'SESSION DETAILS'],
                [ 'Location', 'Site code'],
                [ this.selectedSession.site_location, this.selectedSession.site_code],
                [ 'Terminal', 'Cashier'],
                [ this.selectedSession.terminal_name, this.selectedSession.user_name]
            ];

        
            var worksheet = XLSX.utils.aoa_to_sheet(basicDetails);

            // Set headers
            var productBreakdownColHeaders = [["Product Inventory Breakdown"]];
            productBreakdownColHeaders.push(['Stock No',  'Product Name',  'Beginning Inventory', '',  'Product In', '', '', '', '',  'Product Out', '', '', '', '', '',  'Ending Inventory', '',  'Product Sold', '']);
            productBreakdownColHeaders.push(['',  '',  'Quantity',  'Total Amount',  'Production',  'Commissary',  'SLD', 'Suppliers', 'Received from other stores', 'Pull Out', 'Bread Discount', 'Garbage Collection', 'Representation', 'Transfer to Other Stores', 'Others', 'Quantity', 'Total Amount', 'Quantity', 'Price', 'Sales']);
            var inventoryValueTableName = [["Inventory Value Breakdown"]];
            var cashMovementTableName = [["Cash Movement Breakdown"]];
            var nonCashTableName = [["Non Cash Breakdown"]];
            var categorySalesTableName = [["Sales by Category Breakdown"]];
            
            var newLine = [[]];
            // Merge some header cells
            
            var merges = [
                 {s: {c: 0, r:9 }, e: {c:0, r:10}}, //A10 to A11
                 {s: {c: 1, r:9 }, e: {c:1, r:10}}, //B10 to B11
                 {s: {c: 2, r:9 }, e: {c:3, r:9}}, //C10 to D10
                 {s: {c: 4, r:9 }, e: {c:8, r:9}}, //E10 to I10
                 {s: {c: 9, r:9 }, e: {c:14, r:9}}, //J10 to O10
                 {s: {c: 15, r:9 }, e: {c:16, r:9}}, //P10 to Q10
                 {s: {c: 17, r:9 }, e: {c:19, r:9}}, //R10 to T10
            ];
            
            // Append breakdown tables
            XLSX.utils.sheet_add_aoa(worksheet, newLine, {origin: -1});
            XLSX.utils.sheet_add_aoa(worksheet, productBreakdownColHeaders, {origin: -1});
            XLSX.utils.sheet_add_aoa(worksheet, tables.writableProductBreakdown, {origin: -1, skipHeader: true});

            XLSX.utils.sheet_add_aoa(worksheet, newLine, {origin: -1});
            XLSX.utils.sheet_add_aoa(worksheet, inventoryValueTableName, {origin: -1});
            XLSX.utils.sheet_add_json(worksheet, tables.writableInventoryBreakdown,{origin: -1});

            XLSX.utils.sheet_add_aoa(worksheet, newLine, {origin: -1});
            XLSX.utils.sheet_add_aoa(worksheet, cashMovementTableName, {origin: -1});
            XLSX.utils.sheet_add_json(worksheet, tables.writableCashMovement, {origin: -1});

            XLSX.utils.sheet_add_aoa(worksheet, newLine, {origin: -1});
            XLSX.utils.sheet_add_aoa(worksheet, nonCashTableName, {origin: -1});
            XLSX.utils.sheet_add_json(worksheet, tables.writableNonCashBreakdown, {origin: -1});

            XLSX.utils.sheet_add_aoa(worksheet, newLine, {origin: -1});
            XLSX.utils.sheet_add_aoa(worksheet, categorySalesTableName, {origin: -1});
            XLSX.utils.sheet_add_json(worksheet, tables.writableCategoryBreakdown, {origin: -1});
            
            worksheet['!merges'] = merges
            worksheet['!cols'] = Array(20).fill({wch: 20});

            XLSX.utils.book_append_sheet(workbook,worksheet, 'Details');
            
            XLSX.writeFile(workbook, `POS_Session_${this.selectedSession.site_code}_${this.selectedSession.business_date_formatted}_#${this.selectedSession.session_id}.xlsx` );
        }
    },
    watch:{
      
    },
}
</script>

<style>
    .selected2{
        background-color:  #EFF6FF;
        color: #2371CC;
    }
</style>